<template>
  <div>
    <div
      v-if="!data.length"
      class="shadow-card rounded-2xl bg-white p-6 md:p-8"
    >
      <EmptySection :title="__('Add companies')">
        <template #icon>
          <Icon class="text-xl text-zinc-200" name="browse" is-filled />
        </template>
      </EmptySection>
    </div>

    <div v-else class="grid gap-4 sm:grid-cols-2 md:grid-cols-3">
      <div
        v-for="company in data"
        :key="company.id"
        class="shadow-card flex flex-col overflow-hidden rounded-lg"
      >
        <div class="grow space-y-2 bg-white px-4 pb-4 pt-5">
          <img
            :src="
              company.logo_url
                ? '/uploads/' + company.logo_url
                : placeholderImage
            "
            :alt="company.name"
            class="h-12"
          />

          <span class="block text-xl text-zinc-800">{{ company.name }}</span>

          <div class="flex flex-wrap gap-2">
            <div v-if="company.location" class="flex items-center gap-1">
              <Icon class="text-xl text-zinc-400" name="distance" is-filled />
              <span class="text-sm text-zinc-800">
                {{ company.location.name }}
              </span>
            </div>

            <div
              v-if="company.work_type.length"
              class="flex items-center gap-1"
            >
              <Icon class="text-xl text-zinc-400" name="work" is-filled />
              <span class="text-sm text-zinc-800">
                {{ company.work_type.map((type) => type.name).join(', ') }}
              </span>
            </div>

            <div v-if="company.employee_number" class="flex items-center gap-1">
              <Icon class="text-xl text-zinc-400" name="group" is-filled />
              <span class="text-sm text-zinc-800">
                {{ `${company.employee_number.name} ${__('Employees')}` }}
              </span>
            </div>

            <a
              v-if="company.website"
              :href="company.website"
              target="_blank"
              class="flex items-center gap-1"
            >
              <Icon class="text-xl text-zinc-400" name="language" is-filled />
              <span class="text-sm text-zinc-800 underline underline-offset-2">
                {{ company.website.replace(/^https?:\/\//, '') }}
              </span>
            </a>
          </div>
        </div>

        <div class="bg-zinc-50 px-4 py-3">
          <Button
            :href="company.profile_url"
            target="_blank"
            variant="outline"
            class="flex w-fit items-center gap-1.5"
          >
            <Icon class="text-xl" name="send" />
            <span>{{ __('View company profile') }}</span>
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { Button } from '@/components/block/button';
  import { Icon } from '@/components/block/icon';
  import { EmptySection } from '@/pages/components/empty-section';

  const props = defineProps({
    data: {
      type: Array,
      required: true
    }
  });

  const placeholderImage = '/images/logo_placeholder.png';
</script>
